<template>
  <div
    class="al-section-hero"
    :class="[{ 'has-not-extra-hero': !hasExtraSlot }, size, { 'is-dark': darkMode }]"
  >
    <div class="al-section-hero-content">
      <div class="al-section-hero-main">
        <slot name="breadcrumb">
          <al-breadcrumb v-if="items" :items="items" />
        </slot>
        <div class="al-section-hero-header">
          <content-editable
            multiline
            :size="size"
            :editable="editable"
            :placeholder="placeholder"
            :value="title"
            :width="450"
            @input="onEdit"
            @blur="onBlur"
          >
            <h1 class="content-editable-item">
              <slot>
                {{ title }}
                <al-badge v-if="state" vertical-align="middle">{{ state }}</al-badge>
              </slot>
            </h1>
            <span slot="placeholder">{{ placeholder }}</span>
          </content-editable>

          <div class="al-section-hero-actions actions-left">
            <a test-id="al-section-hero__button" :href="href" @click="$emit('to')">
              <al-icon v-if="icon" :icon="icon" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="hasExtraSlot" class="al-section-hero-extra">
      <slot name="extra">este es el extra</slot>
    </div>
  </div>
</template>

<script>
import AlBreadcrumb from '../../../core/breadcrumb/AlBreadcrumb.vue';
import AlIcon from '../../../core/inline/icon/AlIcon.vue';
import ContentEditable from '../../../core/inline/content-editable/ContentEditable.vue';
import AlBadge from '../../../core/inline/badge/AlBadge.vue';

export default {
  components: {
    AlBreadcrumb,
    AlIcon,
    ContentEditable,
    AlBadge
  },
  model: {
    prop: 'title',
    event: 'input'
  },
  props: {
    title: {
      type: String,
      default: null
    },
    state: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    editable: { type: Boolean, defaault: false },
    items: {
      type: Array,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    href: {
      type: String,
      // eslint-disable-next-line no-script-url
      default: 'javascript:;'
    },
    size: {
      type: String,
      default: 'lg'
    },
    darkMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      max_length: 70,
      i18nRoot: 'learning.admin',
      i18n: {
        max_length_exceeded: 'common.max_length_exceeded'
      }
    };
  },
  computed: {
    hasExtraSlot() {
      return !!this.$slots.extra;
    }
  },
  methods: {
    onBlur(value) {
      if (!this.maxLenghtExceeded(value)) {
        this.$emit('blur', value);
      } else {
        this.$lrnToast.error(this.$tc_plvx(this.i18n.max_length_exceeded));
      }
    },
    onEdit(text) {
      if (!this.maxLenghtExceeded(text)) {
        this.$emit('input', text);
      } else {
        this.$lrnToast.error(this.$tc_plvx(this.i18n.max_length_exceeded));
      }
    },
    maxLenghtExceeded(str = '') {
      return str.trim().length > this.max_length;
    }
  }
};
</script>

<style lang="scss">
/**
 * Variables
 */
.al-section-hero {
  $font-color: #36403f;
  $font-color-dark: #fff;
  $font-size: 25px;
  $font-size-md: 20px;

  $mb-navigation: 4px;

  $w-actions-left: 24px;
  $h-actions-left: 24px;
  $p-actions-left: -50px;
  $font-color-actions-left: #04100f;
  display: flex;

  padding-bottom: 40px;
  width: 100%;

  .content-editable {
    left: -9px;

    .content-editable-input {
      width: calc(100% + 9px);
    }

    &.md,
    &.lg {
      left: -9px;

      .content-editable-input {
        width: calc(100% + 9px);
      }
    }
  }

  .al-breadcrumb {
    margin-bottom: $mb-navigation;
  }

  .al-section-hero-content {
    align-items: center;
    display: flex;
    flex-grow: 2;
    justify-content: space-between;
    position: relative;

    .al-section-hero-main {
      margin-right: $w-actions-left;
      width: 100%;
    }

    .content-editable-item {
      color: $font-color;
      font-family: 'artura', Helvetica;
      font-size: $font-size;

      .al-icon {
        display: inline-flex;
        min-width: 24px;
      }

      h1 {
        margin: 0;

        .al-badge {
          margin: 0;
          margin-left: 10px;
          position: relative;
          top: -5px;
        }

        .al-icon {
          margin-right: 8px;
        }
      }
    }

    .al-section-hero-header {
      align-items: center;
      display: flex;
      min-height: 40px;
      position: relative;
    }

    .al-section-hero-actions {
      align-items: center;
      display: flex;
      height: $h-actions-left;
      justify-content: center;
      left: $p-actions-left;
      position: absolute;
      top: 12px;
      width: $w-actions-left;

      a {
        align-items: center;
        display: flex;
      }

      a,
      a:active,
      button {
        background-color: transparent;
        color: $font-color-actions-left;
        text-decoration: none;
      }
    }
  }

  &.is-dark {
    .content-editable-item {
      color: $font-color-dark;
    }
  }

  &.md {
    .al-section-hero-content {
      .content-editable-item {
        font-size: $font-size-md;
      }
    }
  }

  &.has-not-extra-hero {
    .al-section-hero-content {
      .al-section-hero-main {
        margin-right: 0;
      }
    }
  }

  .al-section-hero-extra {
    display: flex;
    margin-left: auto;
    text-align: right;
  }
}
</style>
